import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation - Reverberation time",
  description: "Reverberation time is given in one-third octave bands with standard deviations.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-2.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
